import { InvalidateQueryFilters, QueryClient } from "@tanstack/react-query";
import { SessionMethodParams, SessionQueryMethodName } from "../../types";
import { buildSessionQueryKey } from "../../keys";

export interface InvalidateSessionQueriesArgs<Method extends SessionQueryMethodName> {
  method: Method;
  request?: Partial<SessionMethodParams<Method>>;
  queryClient: QueryClient;
  filters?: Omit<InvalidateQueryFilters, "queryKey">;
}

export const invalidateSessionQueries = async <Method extends SessionQueryMethodName>({
  method,
  request,
  queryClient,
  filters,
}: InvalidateSessionQueriesArgs<Method>): Promise<void> => {
  const queryKey = buildSessionQueryKey({ method, request });

  await queryClient.invalidateQueries({
    ...filters,
    queryKey,
  });
};
